
import React from 'react';
import { HotelEditForm } from './HotelEditForm';
import { HotelGrid } from './HotelGrid';
import { HotelDetailsCard } from './HotelDetailsCard';
import { useHotelsList } from '@/hooks/hotels/useHotelsList';
import { HotelDetails } from '@/types/itinerary';
import { useIsMobile } from '@/hooks/use-mobile';

interface HotelListProps {
  tripId: string;
}

export const HotelList: React.FC<HotelListProps> = ({ tripId }) => {
  const isMobile = useIsMobile();
  const {
    hotels,
    editingHotelId,
    removeHotel,
    editHotel,
    handleEditComplete
  } = useHotelsList(tripId);

  return (
    <div className="space-y-6 w-full">
      {/* Show edit form when an item is being edited */}
      {editingHotelId && (
        <HotelEditForm
          editingHotelId={editingHotelId}
          onEditComplete={handleEditComplete}
          tripId={tripId}
        />
      )}
      
      {/* Display hotel details card for each hotel */}
      {!editingHotelId && hotels.map(hotel => {
        const hotelDetails: HotelDetails = {
          name: hotel.name,
          address: hotel.address,
          checkIn: hotel.checkIn,
          checkOut: hotel.checkOut,
          confirmation: hotel.confirmation,
          notes: hotel.notes,
          price: hotel.price,
          phone: hotel.phone,
          addedBy: hotel.addedBy || 'Unknown',
          roommates: Array.isArray(hotel.roommates) ? hotel.roommates : [],
          tripId: hotel.tripId
        };
        
        return (
          <HotelDetailsCard 
            key={hotel.id} 
            hotel={hotelDetails}
          />
        );
      })}
      
      {/* Always display the hotel grid when not editing */}
      {!editingHotelId && (
        <div className={isMobile ? "w-full overflow-x-auto pb-4" : ""}>
          <HotelGrid 
            hotels={hotels}
            onRemove={removeHotel}
            onEdit={editHotel}
          />
        </div>
      )}
    </div>
  );
};
